import { render } from "./CompanySectorList.vue?vue&type=template&id=3f33d23a&scoped=true"
import script from "./CompanySectorList.vue?vue&type=script&lang=js"
export * from "./CompanySectorList.vue?vue&type=script&lang=js"

import "./CompanySectorList.vue?vue&type=style&index=0&id=3f33d23a&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f33d23a"]])

export default __exports__